export default {
  getInstructorName: content => {
    return content?.instructors[0]?.name ?? 'INE Instructor'
  },
  getVendorName: content => {
    const { vendor, vendors } = content
    if (vendor && typeof vendor === 'string') {
      return vendor
    }
    if (vendor && vendor.name) {
      return vendor.name
    }
    if (vendors && vendors.length) {
      return vendors[0].name
    }
    return 'INE'
  },
  getLearningAreaName: content => {
    return content?.learning_areas[0]?.name ?? 'INE'
  },
}
